import './Attributes.css'

export default function Attributes() {
  console.log('Attributes rendered')

  return (
    <div className="attributes-page">
      <div className="attributes-container">
        <h3>Attributes</h3>
        <div className="attributes-form-container">
        </div>
      </div>
    </div>
  )
}
